import { action, observable } from 'mobx';
import services from '../services';

class QuestionsStore {
    @observable loadingData = false;
    @observable error = null;
    @observable question = null;
    @observable questionAnswers = null;

    constructor(companyStore) {
        this.companyStore = companyStore;
    }

    @action setError = (error) => {
        this.error = error;
    };

    @action
    async loadQuestion(companyId, id, assessmentId, background) {
        if (!background) {
            if (this.loadingData === id) return;
            this.loadingData = id;
        }
        this.setError(null);
        try {
            this.question = await services.Companies.questionsService(
                companyId
            ).getPersonalizedQuestion(id, assessmentId);
        } catch (e) {
            this.setError(
                (e.response && e.response.data && e.response.data.error) ||
                    e.message
            );
        } finally {
            this.loadingData = null;
        }
    }
}

export default QuestionsStore;
